const INPUT_NUMBER_SELECTOR = '.el-input-number .el-input__inner'
const installedDocumentSet = new WeakSet()

function selectInputNumberText(inputElement) {
  try {
    inputElement.select()
  } catch {
    // 原生全选不可用时，仍保留首次输入覆盖逻辑。
  }
}

function selectInputNumberValue(inputElement) {
  selectInputNumberText(inputElement)

  if (inputElement.type === 'number') {
    const replaceCurrentValue = (value) => {
      cleanup()
      // 相同值赋值会保留原生选区，先清空以免下一位输入继续覆盖。
      if (inputElement.value === value) inputElement.value = ''
      inputElement.value = value
      const InputEventConstructor = inputElement.ownerDocument?.defaultView?.InputEvent
      const EventConstructor = inputElement.ownerDocument?.defaultView?.Event
      const inputEvent = InputEventConstructor
        ? new InputEventConstructor('input', {
            bubbles: true,
            data: value,
            inputType: 'insertText',
          })
        : new EventConstructor('input', { bubbles: true })
      inputElement.dispatchEvent(inputEvent)
    }
    const replaceFirstKey = (event) => {
      if (event.ctrlKey || event.metaKey || event.altKey || !/^[0-9.+-]$/.test(event.key)) {
        return
      }
      event.preventDefault()
      replaceCurrentValue(event.key)
    }
    const replaceFirstInput = (event) => {
      if (!['insertText', 'insertCompositionText', 'insertFromPaste'].includes(event.inputType) || !event.data) {
        return
      }
      event.preventDefault()
      replaceCurrentValue(event.data)
    }
    const cleanup = () => {
      inputElement.removeEventListener('keydown', replaceFirstKey, true)
      inputElement.removeEventListener('beforeinput', replaceFirstInput, true)
      inputElement.removeEventListener('blur', cleanup, true)
    }
    inputElement.addEventListener('keydown', replaceFirstKey, true)
    inputElement.addEventListener('beforeinput', replaceFirstInput, true)
    inputElement.addEventListener('blur', cleanup, {
      capture: true,
      once: true,
    })
    return
  }
}

/**
 * 为当前应用中的 Element Plus 数字输入框安装聚焦及点击全选行为。
 *
 * @param {Document} targetDocument 目标文档
 */
export function installInputNumberSelectOnFocus(targetDocument = document) {
  if (!targetDocument || installedDocumentSet.has(targetDocument)) return

  targetDocument.addEventListener(
    'focusin',
    (event) => {
      const inputElement = event.target
      if (!inputElement?.matches?.(INPUT_NUMBER_SELECTOR)) return
      if (inputElement.disabled || inputElement.readOnly) return

      selectInputNumberValue(inputElement)
    },
    true,
  )

  // 点击发生在鼠标默认放置光标之后，再次全选以保留可见选区。
  targetDocument.addEventListener('click', (event) => {
    const inputElement = event.target
    if (!inputElement?.matches?.(INPUT_NUMBER_SELECTOR)) return
    if (inputElement.disabled || inputElement.readOnly) return
    if (targetDocument.activeElement !== inputElement) return

    selectInputNumberText(inputElement)
  })

  installedDocumentSet.add(targetDocument)
}
